import { Component, Input } from '@angular/core';
import { AdminFileManagementUploadComponent } from "../admin-file-management-upload/admin-file-management-upload.component";
import { FileManagementService } from '../../../../core/api/file-management.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { AdminFileGet, AdminFileType } from '../../../../core/interfaces/file-management-interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { TranslocoPipe } from '@jsverse/transloco';
import { IsoToFormattedDatePipe } from "../../../../core/pipes/iso-to-formatted-date.pipe";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-gas-distribution-tariff-files',
  standalone: true,
  imports: [AdminFileManagementUploadComponent, TranslocoPipe, IsoToFormattedDatePipe, CommonModule],
  templateUrl: './admin-gas-distribution-tariff-files.component.html',
  styleUrl: './admin-gas-distribution-tariff-files.component.css'
})
export class AdminGasDistributionTariffFilesComponent {
  constructor(private fileManagement: FileManagementService, private apiError: ApiErrorService) { }
  AdminFileType = AdminFileType;
  @Input() toast?: ToastComponent;

  gasDistributionTariffFiles: AdminFileGet[] = [];

  ngOnInit(): void {
    this.loadGasDistributionTariffs();
  }

  loadGasDistributionTariffs() {
    this.fileManagement.getGasDistributionTariffs().subscribe({
      next: (response) => {
        if (response) {
          this.gasDistributionTariffFiles = [];
          this.gasDistributionTariffFiles = response;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
      }
    });
  }

  async getFileManagementFileUrl(fileId: string) {
    try {
      var response = await lastValueFrom(this.fileManagement.downloadFile(fileId));
      return response.download_url;

    } catch (error) {
      var crid = 'UNKNOWN-CRID';

      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
    }
    return null;
  }

  async downloadFile(fileId: string) {
    const fileUrl = await this.getFileManagementFileUrl(fileId || '');
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  }
}
